import React from 'react'
import './SidePanel.sass'

function SidePanel({ title, buttons = null, content }) {
  return (
    <div className="SidePanel">
      <div className="Title">
        {title} {buttons && <div className="Buttons">{buttons}</div>}
      </div>
      <div className="Content">{content}</div>
    </div>
  )
}

export default SidePanel
